/**
 * Snap point helpers for @gorhom/bottom-sheet.
 * Percent strings only; see applyExpandedLayoutSnapBoost.
 */

const PERCENT_SNAP_RE = /^(\d+(?:\.\d+)?)%$/;

/** Boost factor when expanded layout (tablet landscape / web per shouldUseExpandedLayout). */
export const EXPANDED_LAYOUT_SNAP_BOOST_FACTOR = 1.2;

/**
 * Multiplies each `NN%` snap by 1.2 (20% boost) and clamps to 100%.
 * Non-matching strings are returned unchanged (pass-through).
 */
export function applyExpandedLayoutSnapBoost(snapPoints: string[]): string[] {
  return snapPoints.map(snap => {
    const trimmed = snap.trim();
    const match = PERCENT_SNAP_RE.exec(trimmed);
    if (!match) {
      return snap;
    }
    const pct = parseFloat(match[1]);
    if (Number.isNaN(pct)) {
      return snap;
    }
    const boosted = Math.min(100, pct * EXPANDED_LAYOUT_SNAP_BOOST_FACTOR);
    const rounded = Math.round(boosted * 100) / 100;
    return `${rounded}%`;
  });
}
